module.exports = __webpack_public_path__ + "img/p_semerdjiev.922b3b52.jpg";